import { LocationOn } from '@mui/icons-material';
import { LocationAttrs, LocationItem } from 'cdx-common';

export const LocationIcon = (props: { location: LocationItem; }) => {
    switch (props.location.type) {
        case 'googleItem':
            return <LocationOn color='disabled' />;
        case 'locationItem':
            return <ExistingLocationIcon location={props.location.data as LocationAttrs} />;
        default:
            return null;
    }
};
export const ExistingLocationIcon = (_props: { location: LocationAttrs; }) => {
    return <LocationOn color='success' />;
};
